import { createStyles } from '@affstore-ds/uikit'

export const usePromoCardLoaderStyles = createStyles((theme) => ({
  root: {
    backgroundColor: theme.other.colors.white[0],
    border: `1px solid ${theme.other.colors.greyIron[4]}`,
    borderRadius: theme.other.borderRadius[8],
    overflow: 'hidden',
  },
}))
